import { render, staticRenderFns } from "./user-manage-log.vue?vue&type=template&id=4703461d&scoped=true"
import script from "./user-manage-log.vue?vue&type=script&lang=js"
export * from "./user-manage-log.vue?vue&type=script&lang=js"
import style0 from "./user-manage-log.vue?vue&type=style&index=0&id=4703461d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4703461d",
  null
  
)

export default component.exports